<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiFileDocumentEditOutline } from "@mdi/js";
export default {
  name: "MdiFileDocumentEditOutline",
  data() {
    return {
      svgPath: mdiFileDocumentEditOutline,
    };
  },
};
</script>
